import {Component} from 'react';
import PropTypes from 'prop-types';

import queryString from 'query-string';

import {helper, http, route, api} from './common/common';

class Access extends Component {
    constructor(props) {
        super(props);

        this._cancelToken = http.CancelToken.source();
        this._state = {};

        const params = helper.sanitizeDict(
            queryString.parse(this.props.location.search), 'state', 'code');

        this._parseState(params['state']);

        this._authAccess(params['code']);
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        return null;
    }

    _parseState = (data) => {
        if (!data) {
            return;
        }

        const temp = atob(data);

        if (!temp) {
            return;
        }

        this._state = JSON.parse(temp);
    }

    _authAccess = (code) => {
        if (!code) {
            this._processError(null);
            return;
        }

        this._requestAuth(code);
    }

    _processError = (error) => {
        this.props.setError(
            'Unauthorized Access',
            'generic',
            'You are not authorized to access this service',
            () => {
                route(this, '/home', '');
            })
    }

    _requestAuth = async (code) => {
        try {
            const response = await http.post(api.access() + '/auth', {
                'auth_code': code,
            }, {
                cancelToken: this._cancelToken.token,
            });

            this.props.setAccessCode(response.data.access_code);

            if (this._state.preSelectRouteTo) {
                route(this, this._state.preSelectRouteTo, this._state.search);
            } else {
                route(this, '/organization-select', '', this._state);
            }
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._processError(error);
        }
    }
}

Access.propTypes = {
    setError: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
}

export default Access;
